import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnChanges,
	inject,
} from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { AuRightSidebarService } from '@app/core/services/au-right-sidebar.service';
import { ACTIVE_PAGE_CONFIG } from '@app/pages/cmms/configs/active-page.config';
import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';
import { IFileEntity } from '@app/pages/cmms/interfaces/files.interfaces';

@Component({
	selector: 'file-notification',
	imports: [MatIconModule],
	templateUrl: './file-notification.component.html',
	styleUrls: ['./file-notification.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileNotificationComponent implements OnChanges {
	@Input() incidentsDetectedAndCreated: { detected: number; created: number };
	@Input() dataExists: boolean;
	@Input() fileEntity: IFileEntity;
	private readonly sidebarService = inject(AuRightSidebarService);

	allCreated: boolean = null;
	ngOnChanges() {
		if (
			this.incidentsDetectedAndCreated.created > 0 &&
			this.incidentsDetectedAndCreated.created ===
				this.incidentsDetectedAndCreated.detected
		) {
			this.allCreated = true;
			return;
		}
		this.allCreated = false;
	}
	viewSelected() {
		this.sidebarService.viewCurrentEntity(
			ACTIVE_PAGE_CONFIG[CmmsPages.editFile].createComponent,
			CmmsPages.editFile,
			{ data: this.fileEntity, entityType: CmmsPages.fileDetector }
		);
	}
}
